import JSX, { h, Component, AnyComponent, ComponentChildren } from 'preact'
import TextButton from '../../control-components/ui-components/TextButton'
import { isFunction } from '../../libs/typeGuards'
import GlobalClick from '../interactive/documentClick'

interface Props {
  popupName: string
  triggerClass?: string
  class?: string
  triggerElement?: AnyComponent<{onClick: (e: Event) => void, disabled?: boolean}> | string
  trigger?: ComponentChildren | ((isTriggerOpen: boolean) => ComponentChildren)
  children: JSX.Element
  closeOnDropdownClick?: boolean
  disabled?: boolean
  onGlobalKey?: (dir: 'up'|'down'|'enter') => void
}

interface State {
  isOpen: boolean
  isTriggerClicked: boolean
}

export default class extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.handleEscapeClick = this.handleEscapeClick.bind(this)
  }

  handleEscapeClick (e: KeyboardEvent) {
    if (e.code === 'Escape') {
      this.setState({ isOpen: false })
      return
    }
    const arrowKeyCallback = this.props.onGlobalKey
    if (!arrowKeyCallback || !this.state.isOpen) return

    if (e.code === 'Enter') {
      arrowKeyCallback('enter')
    } else if (e.code === 'ArrowDown') {
      arrowKeyCallback('down')
      e.preventDefault()
    } else if (e.code === 'ArrowUp') {
      arrowKeyCallback('up')
      e.preventDefault()
    }
  }

  componentDidMount () {
    window.addEventListener('keydown', this.handleEscapeClick)
  }

  componentWillUnmount () {
    window.removeEventListener('keydown', this.handleEscapeClick)
  }

  render (props: Props) {
    let trigger: ComponentChildren = null
    if (typeof props.trigger === 'function') {
      trigger = props.trigger(this.state.isOpen)
    }
    const Trigger = props.triggerElement || TextButton
    return (
      <div className={`dropdown-container ${props.triggerClass || ''}`}>
        <Trigger
          aria-haspopup={props.popupName}
          aria-expanded={this.state.isOpen}
          disabled={props.disabled}
          onClick={() => {
            if (props.disabled) {
              return
            }
            this.setState({ isOpen: !this.state.isOpen, isTriggerClicked: true })
          }}
        >
          {trigger ?? props.trigger}
        </Trigger>
        <GlobalClick
          Component='ul'
          tabIndex={-1}
          role={props.popupName}
          className={`${props.class || ''} ${!this.state.isOpen ? 'is-hidden' : ''}`}
          onChildrenClick={() => props.closeOnDropdownClick ? this.setState({ isOpen: false, isTriggerClicked: false }) : ''}
          onGlobalClick={() => {
            this.state.isTriggerClicked ? this.setState({ isTriggerClicked: false }) : this.setState({ isOpen: false, isTriggerClicked: false })
          }}
        >
          {isFunction(props.children[0]) && props.children[0]({
            close: () => this.setState({ isOpen: false, isTriggerClicked: false })
          })}
          {props.children}
        </GlobalClick>
      </div>
    )
  }
}
